import React from 'react'
import styled from 'styled-components'
import propTypes from 'prop-types'
import Section from 'Documents/publish/components/section'

const Sections = ({
  namespace,
  workspace,
  slug,
  version,
  section: currentSectionID,
  activeTabId,
  topLevelSections,
  themeColor
}) => (
  <SectionWrapper>
    <SectionScroller>
      {(topLevelSections &&
        topLevelSections.length &&
        topLevelSections.map(sectionData => (
          <Section
            key={sectionData.id}
            sectionData={sectionData}
            topLevelGroup
            themeColor={themeColor}
            currentSectionID={currentSectionID}
            activeTabId={activeTabId}
            namespace={namespace}
            workspace={workspace}
            slug={slug}
            version={version}
          />
        ))) || (
        <div className="mx-2">
          <NoSectionsItem>
            <NoSectionTitle>No published sections</NoSectionTitle>
          </NoSectionsItem>
        </div>
      )}
    </SectionScroller>
  </SectionWrapper>
)

Sections.propTypes = {
  namespace: propTypes.string,
  workspace: propTypes.string,
  slug: propTypes.string,
  version: propTypes.string,
  // The currently navigated section ID
  section: propTypes.string,
  activeTabId: propTypes.number,
  topLevelSections: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.number,
      group_id: propTypes.number,
      item_type: propTypes.string,
      title: propTypes.string,
      color: propTypes.string,
      icon: propTypes.string,
      // JSONified array string. will be converted to an array of NestedSection
      sections: propTypes.string,
      // JSONified array string. will be converted to an array of ids. ids will be numbers.
      section_ids: propTypes.string
    })
  ),
  themeColor: propTypes.string
}

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`

const SectionScroller = styled.div`
  flex: 1;
  overflow: auto;
  padding: 10px 12px 30px 12px;
`

const NoSectionsItem = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
  padding: 3px 8px;
  border-radius: 3px;
  cursor: pointer;
  background-color: ${props => props.theme.hoverBgLightestInverse};
  text-decoration: none;
`

const NoSectionTitle = styled.span`
  font-size: 14px;
  padding: 10px 0;
  flex: 1;
  font-weight: 500;
  text-decoration: none !important;
  display: block;
  color: ${({ $active, $themeColor, $hasParent, theme }) => {
    if ($active) {
      return `${$themeColor} !important`
    }
    return $hasParent ? `${theme.textGreyTintedLighter} !important` : `${theme.textGreyTintedDarker} !important`
  }};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export default Sections
